<template>
    <div class="roadTransport">
        <div>
            <banner :themeColor="'#fff'"></banner>
        </div>

        <div class="container">
            <!-- 顶部介绍区域 -->
            <div class="mainTit">两大核心物流，全程保障您的全球贸易畅通</div>
            <div class="topIntro">
                <div class="cardBox">
                    <div class="cardItem">
                        <img src="../../../assets/images/trzx.png" alt="TIR专线">
                    </div>
                    <div class="cardItem">
                        <img src="../../../assets/images/gjhy.png" alt="国际海运">
                    </div>
                </div>
                <div class="introTit">商通中心为企业提供一站式的国际物流综合服务</div>
                <div class="introDesc">
                    依托经认证的TIR运输资质与全球化的海运网络资源，确保货物从起运地到目的地的全程高效流通。通过专业化的运输协调与合规操作，我们保障货物在主要跨境通道上实现快速通关与稳定运输，显著降低企业的国际物流成本。我们致力于以可靠的端到端供应链服务，为您的全球贸易拓展提供坚实、便捷的物流支撑。
                </div>
            </div>

            <div class='tabBox'>
                <div :class="showFlag == item.id ? 'tabItemchooseactive' : 'tabItemchoose'"
                    v-for='(item, index) in navList' :key='index' @click='handleclickitem(item.id)'>{{ item.label }}
                </div>
            </div>

            <div class='gjdlBox' v-if='showFlag == 1'>
                <div class="gjystitle">国际道路运输</div>
                <div class="gjyswrite">TlR(Transports Internationaux
                    Routiers，国际公路运输公约)是由联合国主导的跨境货运通关系统，覆盖全球80+国家(包括中国、俄罗斯、欧盟、中亚等) 货物在启运国海关验封后，途经各国无需重复开箱查验，直达目的地。</div>
            </div>

            <div class='gjdlBox gjdlBoxhy' v-if='showFlag == 2'>
                <div class="gjystitle">国际海洋运输</div>
                <div class="gjyswrite">
                    与国内头部海运服务商山东港口渤海湾港（潍坊港）达成战略合作合作，专注国际海运物流与港口操作，汇聚资深港口操作专家及船舶代理团队，为您提供从货物抵港至装船离港的全链路一站式服务。专业涵盖码头预约、抵港核入、堆场管理、报关协同、船舶配载及装船作业等核心环节，致力于通过精细化现场协调与数字化监控，高效保障货物安全合规装船、准时离港，为您的全球供应链提供坚实稳定的海运支点。
                </div>
            </div>

            <!-- 国际道路运输特色卡片 -->
            <div class="midBox" v-if='showFlag == 1'>
                <div class="columnBox">
                    <div class="tabContent">
                        <div class="tabItem">
                            <div class="rowBox1">
                                <div class="boxItem">
                                    <div class="boxLeft">
                                        <img src="../../../assets/images/gaoxiao.png" alt="">
                                    </div>
                                    <div class="boxRight">
                                        <div class="tit">高效通关</div>
                                        <div class="infoT">
                                            减少边境滞留时间(平均节省50%以上)，提升运输时效。
                                        </div>
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <div class="boxLeft">
                                        <img src="../../../assets/images/jdcb.png" alt="">
                                    </div>
                                    <div class="boxRight">
                                        <div class="tit">降低成本</div>
                                        <div class="infoT">
                                            免除过境国保证金(传统运输需缴纳高额押金)降低企业资金压力。
                                        </div>
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <div class="boxLeft">
                                        <img src="../../../assets/images/anquan.png" alt="">
                                    </div>
                                    <div class="boxRight">
                                        <div class="tit">安全可靠</div>
                                        <div class="infoT">
                                            全程电子化追踪+海关铅封，货物安全有保障。
                                        </div>
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <div class="boxLeft">
                                        <img src="../../../assets/images/fanwei.png" alt="">
                                    </div>
                                    <div class="boxRight">
                                        <div class="tit">覆盖广泛</div>
                                        <div class="infoT">
                                            连接亚欧大陆核心物流通道，尤其适合中欧班列衔接段的公路运输。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 物流服务产品 -->
            <div class="btmBox" v-if='showFlag == 1'>
                <div class="boxTit">物流服务产品</div>
                <div class='sjcpBox'>
                    <div class='carouselWrap'>
                        <!-- 自定义左箭头 -->
                        <div class='customArrow customArrow--left' @click="carouselRef && carouselRef.prev()">
                            <i class='el-icon'><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"/></svg></i>
                        </div>

                        <el-carousel ref="carouselRef" :interval="4000" :arrow="'never'" height='9rem' indicator-position="outside"
                            class='carouselBox' autoplay>
                            <el-carousel-item v-for="(item, index) in shopList" :key="index">
                                <div class='listBox'>
                                    <div class='listItem'>
                                        <div class='zhoubao'>
                                            <div class='zbName'>{{ item.cpmc }}</div>
                                            <img :src="commenUrl + item.zstp" class='titleImg' alt="" v-if='item.zstp'>
                                        </div>
                                        <div class='itemBottom'>
                                            <div class='nrmk'>
                                                <div class='zbnrbt'>服务内容</div>
                                                <div class='nrWrite'>{{ item.fwnr }}</div>
                                            </div>
                                            <div class='nrmk'>
                                                <div class='zbnrbt'>应用场景</div>
                                                <div class='nrWrite'>{{ item.yycj }}</div>
                                            </div>
                                            <div class='nrmk'>
                                                <div class='zbnrbt'>服务对象</div>
                                                <div class='nrWrite'>{{ item.fwdx }}</div>
                                            </div>
                                            <div class='qwcg' @click=goPage(item.lj)>前往采购</div>
                                        </div>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>

                        <!-- 自定义右箭头 -->
                        <div class='customArrow customArrow--right' @click="carouselRef && carouselRef.next()">
                            <i class='el-icon'><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.624a32 32 0 0 0 0-45.248L382.592 149.376a29.12 29.12 0 0 0-41.728-.064z"/></svg></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 国际海运服务流程 -->
            <div class='hyfwlcBox' v-if='showFlag == 2'>
                <div class='hyfwlc'>
                    <div class='title'>国际海运港口全链路服务流程</div>
                    <div class='lcBox'>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc1.png')" fit="contain" />
                            <div class='write'>接收预报与信息确认</div>
                        </div>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc2.png')" fit="contain" />
                            <div class='write'>抵港核入与手续办理</div>
                        </div>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc3.png')" fit="contain" />
                            <div class='write'>堆场落箱与报告发送</div>
                        </div>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc4.png')" fit="contain" />
                            <div class='write'>报关报检与海关放行</div>
                        </div>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc5.png')" fit="contain" />
                            <div class='write'>离港信息与客户同步</div>
                        </div>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc6.png')" fit="contain" />
                            <div class='write'>单证交接与船舶离港</div>
                        </div>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc7.png')" fit="contain" />
                            <div class='write'>装船作业与货物固定 </div>
                        </div>
                        <div class="lcitem">
                            <el-image class='clImg' :src="require('../../../assets/images/lc8.png')" fit="contain" />
                            <div class='write'>船舶配载与计划确认</div>
                        </div>
                    </div>

                    <div class='title' style='margin-top:0.2rem'>相关业务文件附件下载</div>
                    <div class='wjxzBox'>
                        <div class="wjxaItem">
                            <el-image class='wordImg' :src="require('../../../assets/images/worldImg.png')"
                                fit="contain" />
                            <a class="dlowname"
                                href="https://mall.nfstzx.com/sr/1537282/22/18/4d21b751f8ac41b9b9ec21f05938616b.doc">港口作业类合同模版</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/4d21b751f8ac41b9b9ec21f05938616b.doc">
                                <el-image class='xiazaiImg' :src="require('../../../assets/images/xiazai.png')"
                                    fit="contain" />
                            </a>
                        </div>
                        <div class="wjxaItem">
                            <el-image class='wordImg' :src="require('../../../assets/images/worldImg.png')"
                                fit="contain" />
                            <a class="dlowname"
                                href="https://mall.nfstzx.com/sr/1537282/22/18/83828b77a7b14a849c7f16134fbfc532.docx">集港业务委托单</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/83828b77a7b14a849c7f16134fbfc532.docx">
                                <el-image class='xiazaiImg' :src="require('../../../assets/images/xiazai.png')"
                                    fit="contain" />
                            </a>
                        </div>
                        <div class="wjxaItem">
                            <el-image class='wordImg' :src="require('../../../assets/images/worldImg.png')"
                                fit="contain" />
                            <a class="dlowname"
                                href="https://mall.nfstzx.com/sr/1537282/22/18/3f9a2430f8744589b6841fcdc2f787a0.docx">卸船业务委托单</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/3f9a2430f8744589b6841fcdc2f787a0.docx">
                                <el-image class='xiazaiImg' :src="require('../../../assets/images/xiazai.png')"
                                    fit="contain" />
                            </a>
                        </div>
                        <div class="wjxaItem">
                            <el-image class='wordImg' :src="require('../../../assets/images/worldImg.png')"
                                fit="contain" />
                            <a class="dlowname"
                                href="https://mall.nfstzx.com/sr/1537282/22/18/fbc2989101694e5fa21b6792a406901f.docx">装船业务委托单</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/fbc2989101694e5fa21b6792a406901f.docx">
                                <el-image class='xiazaiImg' :src="require('../../../assets/images/xiazai.png')"
                                    fit="contain" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 咨询服务的 -->
            <div class='bdBox' v-if='showFlag == 2'>
                <zxfw></zxfw>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, getCurrentInstance, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
// import banner from '@/components/banner.vue'
import banner from '@/components/bannerMobile.vue'
import zxfw from './zxfu.vue'

export default {
    name: "roadTransport",
    props: {
        themeColor: {
            type: String,
            default: 'blue'
        },
    },
    components: {
        banner,
        zxfw
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        const carouselRef = ref(null);

        // 页面跳转
        const goPage = (url) => {
            if (url) {
                window.open(url);
            }
        };

        // 获取物流服务产品列表
        const shopList = ref([])
        const getsjcpShop = () => {
            proxy.$request({
                url: 'QPSTZX_INDEX_WLCPLIST',
                method: "post",
                data: {}
            }).then((res) => {
                if (res.data.code == '000') {
                    shopList.value = res.data.result
                }
            })
        }
        getsjcpShop()

        // tab 切换
        const showFlag = ref('1')
        const navList = ref([
            { label: '国际道路运输', id: '1' },
            { label: '国际海洋运输', id: '2' },
        ])

        const handleclickitem = (id) => {
            showFlag.value = id
        }

        return {
            goPage,
            shopList,
            getsjcpShop,
            navList,
            showFlag,
            handleclickitem,
            carouselRef
        }
    },
}
</script>
<style lang="less" scoped>
.roadTransport {
    width: 100%;
    background: #F7F7F7;
    box-sizing: border-box;
    padding-top:1rem;
    .container {
        padding: 0.3rem 0.32rem 0.1rem;
    }

    .mainTit {
        font-size: 0.32rem;
        font-weight: 600;
        color: #191919;
        text-align: center;
        margin-bottom: 0.3rem;
    }

    // 顶部介绍区域
    .topIntro {
        background: #fff;
        border-radius: 0.2rem;
        padding: 0.3rem;
        margin-bottom: 0.3rem;

        .cardBox {
            display: flex;
            gap: 0.2rem;
            margin-bottom: 0.3rem;

            .cardItem {
                flex: 1;
                height: 1.5rem;
                background: #f0f5ff;
                border-radius: 0.15rem;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
        }

        .introTit {
            font-size: 0.26rem;
            font-weight: 600;
            color: #191919;
            margin-bottom: 0.15rem;
        }

        .introDesc {
            font-size: 0.24rem;
            color: #595959;
            line-height: 1.6;
        }
    }

    // Tab 切换
    .tabBox {
        display: flex;
        justify-content: center;
        margin-bottom: 0.3rem;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }

        .tabItemchoose,
        .tabItemchooseactive {
            flex-shrink: 0;
            font-size: 0.28rem;
            font-weight: 400;
            color: #1A1A1A;
            padding: 0.2rem 0.3rem;
            position: relative;
            cursor: pointer;
        }

        .tabItemchooseactive {
            color: #1A1A1A;
            font-weight: 600;

            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 0.48rem;
                height: 0.05rem;
                background: #191919;
            }
        }
    }

    // 国际道路/海洋运输介绍
    .gjdlBox {
        width: 100%;
        min-height: 2.6rem;
        background: url('../../../assets/images/TIR.png') no-repeat;
        background-size: 100% 100%;
        margin-bottom: 0.4rem;
        padding: 0.36rem 0.32rem;
        border-radius: 0.2rem;

        .gjystitle {
            font-size: 0.34rem;
            font-weight: 900;
            color: #191919;
            line-height: 1.4;
            text-align: left;
            margin-bottom: 0.16rem;
        }

        .gjyswrite {
            font-size: 0.24rem;
            color: #191919;
            line-height: 1.6;
            text-align: left;
        }
    }

    .gjdlBoxhy {
        background: url('../../../assets/images/seaH5.png') no-repeat;
        background-size: 100% 100%;
    }

    // 特色卡片
    .midBox {
        .columnBox {
            .tabContent {
                .tabItem {
                    .rowBox1 {
                        display: flex;
                        flex-direction: column;
                        gap: 0.2rem;
                        margin-bottom: 0.3rem;

                        .boxItem {
                            width: 100%;
                            padding: 0.26rem;
                            background: #fff;
                            border-radius: 0.32rem;
                            display: flex;

                            .boxLeft {
                                width: 0.56rem;
                                height: 0.56rem;
                                margin-right: 0.2rem;
                                flex-shrink: 0;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                }
                            }

                            .boxRight {
                                flex: 1;
                                display: flex;
                                flex-direction: column;

                                .tit {
                                    font-weight: 600;
                                    font-size: 0.28rem;
                                    color: #191919;
                                    margin-bottom: 0.05rem;
                                }

                                .infoT {
                                    font-size: 0.24rem;
                                    color: #595959;
                                    line-height: 1.4;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    // 物流服务产品
    .btmBox {
        margin-bottom: 0.4rem;

        .boxTit {
            font-size: 0.32rem;
            font-weight: 600;
            color: #191919;
            text-align: center;
            padding: 0.2rem 0 0.4rem;
        }

        .sjcpBox {
            width: 100%;

            .carouselWrap {
                position: relative;

                // 自定义箭头 - 绝对定位贴在listBox两侧
                .customArrow {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 0.6rem;
                    height: 0.6rem;
                    border-radius: 50%;
                    background: rgba(0, 0, 0, 0.2);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    z-index: 10;

                    .el-icon {
                        width: 0.32rem;
                        height: 0.32rem;
                        color: #fff;

                        svg {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    &:active {
                        background: rgba(0, 0, 0, 0.4);
                    }

                    &.customArrow--left {
                        left: -10px;
                    }

                    &.customArrow--right {
                        right: -10px;
                    }
                }

                // 轮播容器
                .carouselBox {
                    width: 100%;

                    ::v-deep(.el-carousel__indicators--outside) {
                        button {
                            width: 0.6rem;
                            height: 0.08rem;
                            border-radius: 0.04rem;
                            background: #D8D8D8;
                        }

                        .el-carousel__indicator.is-active button {
                            background: #000;
                        }
                    }

                    ::v-deep(.el-carousel__item) {
                        height: auto;
                    }
                }
            }

            .listBox {
                width: 100%;
                height: 9rem;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
                gap: 0.15rem;

                .listItem {
                    width: 100%;
                    background: #fff;
                    border-radius: 0.2rem;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;

                    .zhoubao {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.15rem;
                        background: #E8F0FF;
                        height: 1.2rem;

                        .zbName {
                            flex: 1;
                            font-size: 0.36rem;
                            font-weight: 600;
                            color: #121C30;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .titleImg {
                            width: 0.32rem;
                            height: 0.32rem;
                            object-fit: contain;
                        }
                    }

                    .itemBottom {
                        flex: 1;
                        padding: 0.15rem;
                        display: flex;
                        flex-direction: column;

                        .nrmk {
                            border-bottom: 1px solid #EBEBEB;
                            padding: 0.4rem 0 0.28rem;
                            height: 2.2rem;
                            box-sizing: border-box;

                            .zbnrbt {
                                font-size: 0.28rem;
                                color: #747C8D;
                                margin-top: 0.12rem;
                            }

                            .nrWrite {
                                font-size: 0.28rem;
                                font-weight: 600;
                                color: #676D7A;
                                line-height: 0.53rem;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                margin-top: 0.2rem;
                            }
                        }

                        .qwcg {
                            width: 2.28rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 0.53rem;
                            border-radius: 0.25rem;
                            border: 1px solid #191919;
                            font-size: 0.24rem;
                            color: #191919;
                            cursor: pointer;
                            background: transparent;
                            margin: 0.3rem auto 0.34rem;
                        }
                    }
                }
            }
        }
    }

    // 国际海运服务流程
    .hyfwlcBox {
        margin-bottom: 0.4rem;

        .hyfwlc {
            background: #fff;
            border-radius: 0.2rem;
            padding: 0.3rem;

            .title {
                font-size: 0.28rem;
                font-weight: 600;
                color: #191919;
                text-align: left;
                margin-bottom: 0.2rem;
            }

            .lcBox {
                .lcitem {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.2rem;

                    .clImg {
                        width: 0.9rem;
                        height: 0.9rem;
                        margin-bottom: 0.1rem;
                    }

                    .write {
                        text-align: center;
                        font-size: 0.28rem;
                        color: #191919;
                        font-weight: 400;
                        margin-left: 0.2rem;
                    }
                }
            }

            .wjxzBox {
                margin-top: 0.3rem;

                .wjxaItem {
                    background: #F8FAFE;
                    padding: 0.2rem;
                    border-radius: 0.1rem;
                    margin-bottom: 0.15rem;
                    display: flex;
                    align-items: center;

                    .wordImg {
                        width: 0.5rem;
                        height: 0.5rem;
                        margin-right: 0.15rem;
                    }

                    .dlowname {
                        flex: 1;
                        font-size: 0.22rem;
                        color: #191919;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .xiazaiImg {
                        width: 0.3rem;
                        height: 0.3rem;
                    }
                }
            }
        }
    }
}
</style>
